<template>
  <div>
    <van-nav-bar :title="generateCustomizeString('customerDetails')" :left-text="generateCustomizeString('goBack')" left-arrow @click-left="onClickLeft" :sticky="true" fixed />
    <div class="customer">
      <van-col span="24">
        <van-col>
          <img height="40" width="40" v-lazy="this.wechatDetail.headimgurl" style="padding-top: 3px; margin-left: 5px;" v-if="this.wechatDetail.headimgurl">
          <img height="40" width="40" :src="customer" style="padding-top: 3px; margin-left: 5px;" v-else>
        </van-col>
        <van-col style="margin-left: 10px; width: 80%;">
          <van-col span="24" v-if="this.wechatDetail.nickname">{{ generateCustomizeString('wechatName') }} {{this.wechatDetail.nickname}}
          </van-col>
          <van-col span="24" v-else>{{ generateCustomizeString('wechatName') }} {{generateCustomizeString('none')}}
          </van-col>
          <van-col span="24" v-if="this.memberDetail.phone">{{ generateCustomizeString('phone') }} {{this.memberDetail.phone}}
          </van-col>
          <van-col span="24" v-else>{{ generateCustomizeString('phone') }} {{generateCustomizeString('none')}}
          </van-col>
        </van-col>
      </van-col>
      <!-- <van-col span="24" v-else>
        <van-col span="24" v-if="this.wechatDetail.nickname">微信昵称：{{this.wechatDetail.nickname}}
        </van-col>
        <van-col span="24" v-else>微信昵称：未绑定
        </van-col>
        <van-col span="24">电话号码：{{this.memberDetail.phone}}
        </van-col>
      </van-col> -->
    </div>
    <van-cell-group style="margin-top: 5px;">
      <van-cell :title="generateCustomizeString('registrationDate')" :value="this.memberDetail.created_at | toLocalTime" />
      <van-cell :title="generateCustomizeString('customerRemark')" :value="this.memberDetail.remark" is-link @click="editRemark" />
      <van-cell :title="generateCustomizeString('level')" :value="this.levelName" is-link @click="editLevel" />
      <van-cell :title="generateCustomizeString('points')" :value="this.memberDetail.points.points" v-if="this.memberDetail.points" />
      <van-cell :title="generateCustomizeString('points')" value="0" v-else />
      <van-cell :title="generateCustomizeString('expense')" :value="'NZD $' + parseFloat(this.memberDetail.points.total_cost / 100).toFixed(2)" v-if="this.memberDetail.points" />
      <van-cell :title="generateCustomizeString('expense')" value="NZD $0.00" v-else />
      <van-cell :title="generateCustomizeString('credit')" :value="'NZD $' + parseFloat(this.memberDetail.credits.credits / 100).toFixed(2)" is-link v-if="this.memberDetail.credits" @click="editCredit" />
      <van-cell :title="generateCustomizeString('credit')" value="NZD $0.00" is-link v-else @click="editCredit" />
    </van-cell-group>
    <van-dialog :title="generateCustomizeString('editLevel')" v-model="editLevelDialog" show-cancel-button :confirmButtonText="generateCustomizeString('confirm')" :cancelButtonText="generateCustomizeString('cancel')" @confirm="levelConfirm">
      <div style="margin-top: 15px; padding: 10px; border-top: 1px #eee solid;">
        <van-cell :title="this.levelNameCopy" :value="generateCustomizeString('edit')" is-link @click="changeLevel" />
      </div>
    </van-dialog>
    <van-dialog :title="generateCustomizeString('editCustomerRemark')" v-model="editRemarkDialog" show-cancel-button :confirmButtonText="generateCustomizeString('confirm')" :cancelButtonText="generateCustomizeString('cancel')" @confirm="editRemarkConfirm">
      <div style="margin-top: 15px; padding: 10px; border-top: 1px #eee solid;">
        <van-field v-model="remark" :label="generateCustomizeString('customerRemark')" :placeholder="generateCustomizeString('pleaseInput')" />
      </div>
    </van-dialog>
    <van-actionsheet v-model="showLevel" :actions="levelOptions" @select="selectLevel" :cancel-text="generateCustomizeString('cancel')" />
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Field, Cell, CellGroup, Row, Col, Button, NavBar, Icon, Dialog, Actionsheet, Toast } from 'vant'
import request from '@/utils/request'
import customer from '@/assets/customer.jpg'

export default {
  name: 'CustomerDetail',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Actionsheet.name]: Actionsheet,
    [Toast.name]: Toast
  },
  data() {
    return {
      memberDetail: [],
      wechatDetail: [],
      levelId: null,
      levelName: '',
      levelNameCopy: '',
      editLevelDialog: false,
      editRemarkDialog: false,
      showLevel: false,
      levelOptions: [],
      customer: customer,
      remark: ''
    }
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.replace({ name: 'Customers' })
    },
    editRemark() {
      this.editRemarkDialog = true
      this.remark = this.memberDetail.remark
    },
    editRemarkConfirm() {
      var data = {
        remark: this.remark
      }
      request({
        url: 'customer/' + this.$route.params.customerId + '/remark',
        method: 'patch',
        data
      })
        .then(response => {
          if (response.status === 0) {
            Toast.success(this.generateCustomizeString('updateRemarkSuccess'))
          } else {
            Toast.fail(this.generateCustomizeString('updateRemarkFail'))
          }
          this.fetchData()
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('updateRemarkFail'))
        })
        .finally(() => {
          this.editRemarkDialog = false
        })
    },
    editLevel() {
      this.editLevelDialog = true
    },
    changeLevel() {
      this.showLevel = true
    },
    selectLevel(item) {
      const levelId = item.level
      const levelName = item.name
      this.levelId = levelId
      this.levelNameCopy = levelName
      this.showLevel = false
    },
    levelConfirm() {
      request({
        url: 'customer/' + this.$route.params.customerId + '/level',
        method: 'patch',
        data: {
          level: this.levelId
        }
      })
        .then(response => {
          this.editLevelDialog = false
          if (response.status === 0) {
            this.fetchData()
            Toast.success(this.generateCustomizeString('updateLevelSuccess'))
          } else {
            Toast.fail(this.generateCustomizeString('updateLevelFail'))
          }
        })
        .catch(error => {
          Toast.fail(this.generateCustomizeString('updateRemarkFail'))
          console.warn(error)
        })
    },
    editCredit() {
      this.$router.push({
        name: 'CustomerCredit',
        params: { creditsId: this.memberDetail.credits.id }
      })
    },
    fetchLevel() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/level/list',
          method: 'get'
        })
          .then(response => {
            this.levelOptions = response.data
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchData() {
      request({
        url: 'customer/' + this.$route.params.customerId,
        method: 'get'
      })
        .then(response => {
          const memberData = response.data
          // const wechatData = response.data.wechat_auths[0].user_info
          this.memberDetail = memberData
          // if (this.memberDetail.created_at) {
          //   this.memberDetail.created_at = this.memberDetail.created_at.replace(/-/g, '/')
          // }
          if (response.data.wechat_auths.length && response.data.wechat_auths[0].user_info) {
            this.wechatDetail = response.data.wechat_auths[0].user_info
          }
          if (this.memberDetail.points) {
            if (this.memberDetail.points.level_info) {
              this.levelName = this.memberDetail.points.level_info.name
            } else if (this.memberDetail.points.level === 0) {
              this.levelName = this.generateCustomizeString('none')
            } else {
              this.levelName = this.generateCustomizeString('none')
            }
          } else {
            this.levelName = this.generateCustomizeString('none')
          }
          this.levelNameCopy = this.levelName
          Toast.clear()
        })
        .catch(error => {
          Toast.clear()
          console.warn(error)
        })
    }
  },
  created: function() {
    Toast.loading({
      mask: true,
      forbidClick: true,
      message: this.generateCustomizeString('loading')
    })
    Promise.all([
      this.fetchLevel()
    ])
      .then(result => {
        this.fetchData()
      })
      .catch(error => {
        console.warn(error)
      })
  }
}
</script>

<style type="text/css">
  .van-field__control {
    line-height: 24px !important;
  }
</style>
<style lang="less" scoped>
.customer {
  margin-top: 44px;
  height: 50px;
  background: #fff;
  padding: 20px;
  line-height: 1.5rem;
}
</style>
